import {BaseIdModel} from 'common-shared';
import {Type} from 'class-transformer';

export class CostPriceComponentSurchargeViewModel extends BaseIdModel {

  SurchargeId: string;
  Price: number;
  @Type(() => Date)
  FromDate?: Date;
  @Type(() => Date)
  ToDate?: Date;
  TypeClv?: string;

  constructor() {
    super();
  }

  static CreateDefault(init?: Partial<CostPriceComponentSurchargeViewModel>) {
    return Object.assign(new CostPriceComponentSurchargeViewModel(), {} as CostPriceComponentSurchargeViewModel, init);
  }
}
